import Heading from "Components/Heading";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import { MdClose, MdDateRange } from "react-icons/md";
import { BiSearch } from "react-icons/bi";
import { MdOutlineRefresh } from "react-icons/md";
import Footer from "Components/Footer";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import TicketAPIs from "../../APIs/ticket";
import { formatDate } from "Helper/Converters";
import { dateType } from "Helper/dropdowns";
import { toast } from "react-toastify";
import AuthAPIs from "../../APIs/auth";
import DataTable from "Components/CustomTable";
import Loader from "Components/Loader";
import SampleDataTable from "Components/DataTables";
import SearchForm from "Components/SearchForm";
import CustomDatePicker from "Components/CustomDatePicker";
import moment from "moment";
import { wrapLastTextInBracketsWithStrong } from "Utils/utils";

const ResignTicket = () => {
  const [checkedItems, setCheckedItems] = useState({});
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const { userId } = useSelector((state) => state.auth);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [searchedData, setSearchedData] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState();
  const [stats, setStats] = useState();
  const [unAssignedTicket, setUnAssignedTicket] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");
  const [loadingComponent, setLoadingComponent] = useState(true);

  const handleSelectionChange = (selectedIds) => {
    setSelectedIds(selectedIds);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "44px", // Set the minimum height as needed
    }),
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems({ ...checkedItems, [name]: checked });
  };

  const getUsers = async () => {
    const users = await AuthAPIs.getAllUsers();
    const customArr = [];
    if (users) {
      users.data?.data?.forEach((item) => {
        const data = {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
        // Only include active users and exclude current user
        if (item?.id !== userId && item?.isActive === true) {
          customArr.push(data);
        }
      });
      customArr.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1;
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      setUsers([{ value: "", label: "Select" }, ...customArr]);
    }
  };

  const getTickets = async () => {
    const tickets = await TicketAPIs.search({
      assignDate: "notNull",
      reAssignTo: null,
      isOfficeClear: false,
      removeOr: true,
      ass_reass_req: false,
      completedDate: null,
    });
    const customArr = [{ value: "", label: "Select" }];
    if (tickets) {
      const arr = [
        ...tickets.data.data.filter((item) => item.assignTo !== null),
      ];
      arr?.forEach((item) => {
        const data = { value: item?.id, label: item?.ticketNo };
        customArr.push(data);
      });
      setUnAssignedTicket(customArr);
    }
    setIsLoading(false);
  };

  const getTicketStats = async () => {
    setIsLoading(true);
    const res = await TicketAPIs.ticketStats();
    if (res) {
      setStats(res.data.data);
    }
  };

  useEffect(() => {
    getTicketStats();
    getUsers();
    getTickets();
  }, []);

  const columns = [
    {
      accessor: "ticketNo",
      Header: "Ticket No",
      Cell: ({ row }) => (
        <a
          onClick={(e) => {
            e.preventDefault();
            const url = `/dashboard/ticket-detail/${row.original.ticketNo}`;
            // Use a unique identifier for the window name, e.g., the ticket ID or a timestamp
            const windowName = `popUpWindow_${row.original.ticketNo}`;
            const windowSize = "width=800,height=600";
            window.open(url, windowName, windowSize);
          }}
          href={`/dashboard/ticket-detail/${row.original.ticketNo}`}
          rel="noopener noreferrer"
          className={`badge ${row.original?.cancelDate && "custom-badge"} ${
            row.original.ticketType == "EMERGENCY" ||
            row.original.priority == "EMERGENCY"
              ? "emergency"
              : row.original.ticketType == "MULTIPLE" ||
                row.original.priority == "MULTIPLE"
              ? "multiple"
              : row.original.ticketType == "PRIORITY" ||
                row.original.priority == "PRIORITY"
              ? "priority"
              : row.original.ticketType == "PROJECT WORK" ||
                row.original.priority == "PROJECT WORK"
              ? "projectWork"
              : row.original.ticketType == "STANDARD" ||
                row.original.priority == "STANDARD"
              ? "standard"
              : "default"
          }`}
        >
          {row.original.ticketNo}
          {row.original?.cancelDate && <span className="cancel-btn"></span>}
        </a>
      ),
    },
    {
      accessor: "location",
      Header: "Location",
      Cell: ({ row }) => {
        return (
          <div style={{ whiteSpace: "pre-line" }}>
            {row?.original?.company_name} {"\n"}
            {row?.original?.contractor_name} {"\n"}
            {row?.original?.digAddress} {"\n"}
            {row?.original?.digCity}
            {row?.original?.region} {"\n"}
            {/* <strong>{`(${row.original.priority})`}</strong> */}
          </div>
        );
      },
    },
    { accessor: "entered", Header: "Entered" },
    {
      accessor: "assigntoo",
      Header: "Assigned To",
      Cell: ({ row }) => <p>{row.original.assigntoo?.firstName}</p>,
    },
    {
      accessor: "assign",
      Header: "Assigned Date",
    },
    {
      accessor: "reassinged",
      Header: "Reassigned To",
      Cell: ({ row }) => <p>{row.original.reassigned?.firstName}</p>,
    },
    { accessor: "reassingndate", Header: "Reassigned Date" },
    {
      accessor: "dueDate",
      Header: "Due",
    },
    { accessor: "completedDate", Header: "Completed" },
    {
      accessor: "code",
      Header: "Station Code",
      Cell: ({ row }) => (
        <p>{row.original.code?.map((item) => item.name).join(", ")}</p>
      ),
    },
    { accessor: "segmet", Header: "Segment" },
  ];

  /**
   * Re-Assign Ticket Submit Handler.
   */
  const reAssignTicket = async () => {
    if (!selectedUser) {
      toast.error("Please Select User to Assign");
      return;
    }
    if (!selectedIds[0]) {
      toast.error("No Tickets Selected.");
      return;
    }
    if (!endDate) {
      toast.error("Please Select Reassign Date.");
      return;
    }
    setIsLoading(true);
    setLoadingComponent(false);
    const res = await TicketAPIs.assignReassignTicket({
      ticketId: selectedIds,
      userId: selectedUser,
      type: "re_assign",
      reAssignDate: moment(endDate).format("YYYY-MM-DD"),
    });
    if (res.data.success) {
      // toast.success("Ticket Re-assigned Successfully");
      const selectedTicketsNumbers = searchedData
        .filter((item) => selectedIds.indexOf(item.id) > -1)
        .map((item) => item.ticketNo);
      setSuccessMsg(
        `Following Tickets ${selectedTicketsNumbers.join(
          ","
        )} has been re-assigned successfully.`
      );
      const updatedTickets = searchedData.filter(
        (item) => selectedIds.indexOf(item.id) === -1
      );
      setSearchedData(updatedTickets);
      setSelectedIds([]);
      setSelectedUser(null);
      setIsLoading(false);
      setEndDate(null);
      setLoadingComponent(true);
    }
    // setSearchedData([]);
    setSelectedIds([]);
    setSelectedUser(null);
    setIsLoading(false);
    setEndDate(null);
    setLoadingComponent(true);
  };

  return (
    <>
      <section>
        <Heading text={"Reassign Tickets"} />

        <Card>
          <SearchForm
            setSearchedData={setSearchedData}
            setIsLoading={setIsLoading}
            filters={{
              // assignDate: "notNull",
              //reAssignTo: null,
              isOfficeClear: false,
              //cancelDate: null,
              completedDate: null,
              removeOr: true,
            }}
            loadDataOnMount={true}
            hiddenElements={[
              "digNearestIntersection",
              "ticketType",
              "typeOfWork",
              "isCompletedTicketOnly",
              "reAssignTo",
            ]}
            from={"ReAssign"}
          />

          <Form>
            <Row>
              <div className="headingBox">
                <h6>Reassign Tickets</h6>
              </div>
              <Col className="column">
                <Form.Group className="form-group">
                  <Form.Label>Reassign To</Form.Label>
                  <Select
                    options={users}
                    styles={customStyles}
                    defaultValue={users[0]}
                    onChange={(selectedOption) => {
                      setSelectedUser(selectedOption.value);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col className="column">
                <Form.Group className="form-group">
                  <Form.Label>Reassigned Date</Form.Label>
                  <div className="datepicker_box">
                    <CustomDatePicker
                      selected={endDate}
                      onSelect={(date) => setEndDate(date)}
                      dateFormat="MM/dd/yyyy"
                    />
                    <span>
                      <MdDateRange />
                    </span>
                  </div>
                </Form.Group>
              </Col>

              <Col className="mb-4 column" style={{ maxWidth: "160px" }}>
                <Button
                  style={{ minHeight: "44px", marginTop: "30px" }}
                  onClick={() => {
                    reAssignTicket();
                  }}
                >
                  <MdOutlineRefresh />
                  Reassign
                </Button>
              </Col>
            </Row>
          </Form>
          {successMsg && (
            <div className="successMsg">
              <strong style={{ margin: 0, color: "rgb(0,120,0)" }}>
                {successMsg}
              </strong>
              <MdClose
                size={20}
                color={"gray"}
                onClick={() => setSuccessMsg("")}
                style={{ position: "absolute", top: 10, right: 10 }}
              />
            </div>
          )}
          {loadingComponent && (
            <SampleDataTable
              columns={columns}
              data={searchedData}
              onSelectionChange={handleSelectionChange}
            />
          )}
          <Footer />
        </Card>
      </section>
    </>
  );
};

export default ResignTicket;
